import { z } from "zod";

// Query-string params arrive as strings, so a boolean filter is sent as the
// literal "true"/"false". z.coerce.boolean() coerces any non-empty string —
// including "false" — to `true`, silently inverting the filter (PRO-10954).
// zQueryBoolean() accepts only real booleans or the strings "true"/"false"
// and maps them to the intended boolean.
function queryBooleanCoerce(v: unknown): boolean {
    if (v === "true") {
        return true;
    }
    if (v === "false") {
        return false;
    }
    if (typeof v === "boolean") {
        return v;
    }
    throw new Error("Expected boolean or boolean string");
}

export const zQueryBoolean = () =>
    z
        .custom<boolean>(
            (v) => typeof v === "boolean" || v === "true" || v === "false",
            { message: "Expected boolean or boolean string" },
        )
        .transform(queryBooleanCoerce);
